module.exports = __webpack_public_path__ + "img/loading.4be3da59.gif";